import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Form, Field } from 'redux-form';
import { checkButtonDisabled } from '../../../utils/forms';
import { VALID_EMAIL_REGEX } from '../../../config/app_config';
import InputField from '../../shared/InputField';

export const FIELD_NAMES = ['email', 'permission'];

export class AddUserForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitFunction: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
  }

  handleOnSubmit = evt => {
    const { submitFunction } = this.props;
    submitFunction(evt);
  };

  render() {
    const { handleSubmit, invalid, submitting } = this.props;

    return (
      <Form
        id="addInstallUser"
        className="invite-user-form padded-form inline-form bg-form"
        onSubmit={handleSubmit(this.handleOnSubmit)}
      >
        <fieldset style={{ marginTop: '1rem' }}>
          <Field
            name="email"
            type="text"
            component={InputField}
            label="Invite User"
            placeholder="email"
            maxLength="255"
          />
          <Field name="permission" type="checkbox" component="input" className="checkBox" />{' '}
          <span className="inline-spaced">Install Admin</span>{' '}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={checkButtonDisabled(invalid, submitting)}
          >
            Invite
          </button>
        </fieldset>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.email || values.email.trim() === '') {
    errors.email = 'Required';
  } else if (!VALID_EMAIL_REGEX.test(values.email)) {
    errors.email = 'Invalid EMAIL';
  }

  return errors;
};

export default reduxForm({
  form: 'addInstallUser',
  validate,
  destroyOnUnmount: true,
})(AddUserForm);
